import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageTitle } from "@/components/app/ui";
import { EventCard, EventFormDialog } from "@/pages/app/Events";
import { api, errMsg } from "@/lib/api";

export default function AdminEvents() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/admin/events").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const add = async (f) => { try { await api.post("/admin/events", f); toast.success("Event published to all subscribers"); load(); return true; } catch (e) { toast.error(errMsg(e)); return false; } };
  const del = async (e) => { await api.delete(`/admin/events/${e.id}`); load(); };
  return (
    <div data-testid="admin-events-page">
      <PageTitle title="Curated industry events" copy="Events added here appear in every subscribed client's Events calendar.">
        <button className="btn-brand" onClick={() => setOpen(true)} data-testid="admin-event-add-btn">Add event</button>
      </PageTitle>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
        {items.map((e) => <div key={e.id} className="relative"><EventCard e={e} /><button onClick={() => del(e)} className="absolute top-4 right-4 text-xs text-red-500" data-testid={`admin-event-delete-${e.id}`}>Delete</button></div>)}
        {items.length === 0 && <p className="text-sm text-muted-foreground">No curated events yet.</p>}
      </div>
      <EventFormDialog open={open} setOpen={setOpen} onSubmit={add} />
    </div>
  );
}
